import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Button from '../components/Button';
import './Landing.css';

const Landing = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/login');
  };

  return (
    <div>
      <Header />
      <div className="landing-container">
        {/* Option 1: General */}
        <div className="landing-section general">
          <h1 className="landing-title">Play Games & Get Rewarded — Anytime, Anywhere!</h1>
          <p className="landing-subtitle">Turn Your Downtime Into Cash</p>
          <div className="content-block">
            <p>Play games and earn real rewards—anytime, anywhere.</p>
            <p>With EarnGain, you can make up to $15 a day just by playing mobile games for a few hours. Whether you’re commuting, waiting in line, or relaxing at home, your phone becomes a simple source of income.</p>
            <h3>Here’s how it works:</h3>
            <p>You play. You earn. We handle the payouts. Get paid daily via PayPal, debit card, or direct bank transfer. No waiting around—your money, your way, every day.</p>
            <h3>Earnings Example:</h3>
            <p>Play 6 hours a day, 5 days a week → earn around $340 per month.</p>
            <h3>Simple, Transparent Pricing</h3>
            <p>EarnGain takes a 35% commission for providing the platform and connecting you with earning opportunities. You keep the other 65%.</p>
            <p className="tagline">Real games. Real payouts.</p>
            <div className="get-started-button">
              <Button onClick={handleGetStarted}>Get Started Now</Button>
            </div>
          </div>
        </div>

        {/* Option 2: Short & Punchy */}
        <div className="landing-section short-punchy">
          <h1 className="landing-title">Play More. Earn Daily.</h1>
          <p className="landing-subtitle">Love mobile games? Turn that screen time into cash.</p>
          <div className="content-block">
            <p>EarnGain lets you play games for real money—up to $15 a day. Get paid every single day via PayPal, card, or bank transfer.</p>
            <h3>The Math:</h3>
            <p>6 hours/day, 5 days/week = ~$340/month.</p>
            <p>We take 35% to keep the platform running. You keep 65%.</p>
            <p className="tagline">No catches. Just cash.</p>
            <div className="get-started-button">
              <Button onClick={handleGetStarted}>Get Started Now</Button>
            </div>
          </div>
        </div>

        {/* Option 3: Trust-Focused */}
        <div className="landing-section trust-focused">
          <h1 className="landing-title">A Legit Way to Earn From Your Phone</h1>
          <p className="landing-subtitle">If you’re spending hours on your phone anyway, why not get paid for it?</p>
          <div className="content-block">
            <p>EarnGain turns mobile gaming into a serious earning opportunity.</p>
            <ul>
              <li>Play up to 6 hours a day</li>
              <li>Earn up to $15/day</li>
              <li>Get paid daily via PayPal, card, or bank</li>
            </ul>
            <h3>Transparent Earnings:</h3>
            <p>You keep 65% of everything you earn. We take 35% as our platform fee.</p>
            <p><strong>Example:</strong> Play 6 hours a day, 5 days a week → $340/month in your pocket.</p>
            <p className="tagline">It’s real. It’s simple. It’s EarnGain.</p>
            <div className="get-started-button">
              <Button onClick={handleGetStarted}>Get Started Now</Button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Landing;